export const structureLevels = {
  SECTOR: 4,
  GROUP: 5
};
